import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';
import { history } from '../../_helpers';


const initialState = { forgotPasswordLoading: true, data: '', error: false, status: false, loaderStatus: false };

export function forgotPasswordReducer(state = initialState, action) {

    switch (action.type) {
        case userProfileConstants.REQUEST_FORGOT_PASSWORD:
            return {
                forgotPasswordLoading: true,
                data: '',
                error: false,
                status: false,
                loaderStatus: true
            };
        case userProfileConstants.RECEIVE_FORGOT_PASSWORD:
          
            //   history.push('/login');
            return {
                forgotPasswordLoading: false,
                data: action.forgotPassword,
                error: false,
                status: true, 
                loaderStatus: false                               
            };
        case userProfileConstants.FORGOT_PASSWORD_ERROR:
            return {
                forgotPasswordLoading: false,
                data: action.error.response.data.response,
                error: true,
                status: false,
                loaderStatus: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/forgotPassword.reducer.js